module.exports = __webpack_public_path__ + "img/2.9ada6e07.png";